
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customvisualizarenelprincipalifwvk_6735058a9633993dfe9ed306 } from '../../api/vehiculosai6rp.api'
import {customcrearharke_67351f269633993dfe9edac8 } from '../../api/cotizacion8c3iv.api'

import './paginaprincipaliigd5.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Ppaginaprincipaliigd5 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyres_6735058a9633993dfe9ed306_component_ipuecp, setloftyres_6735058a9633993dfe9ed306_component_ipuecp] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customvisualizarenelprincipalifwvk_6735058a9633993dfe9ed306({
				});
				setloftyres_6735058a9633993dfe9ed306_component_ipuecp(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id672cf18ee110d14092e8cac7" >

      <div id="iw4j" className="">
      
      <div id="ifxeud" className="">
      
      <div id="it2j54" className="">
      
      <div id="ips2" className="">
      
      <div
        id="idiuka"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="1000"
      >
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim3j34g0c.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/vehiculos"
        type=""
      >
        <>Búsqueda de Vehículos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/formulario"
        type=""
      >
        <>Cotización</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="i29u1z"
        className=""
        data-aos="zoom-in-up"
        data-aos-duration="1000"
      >
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className="links "
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className="links "
        id="iwu1w"
        href="/vehiculos"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <>Búsqueda de Vehículos</>
    </div>
    
      </a>
      
      <a
        target=""
        className="links "
        id="i31ek"
        href="/formulario"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>Cotización</>
    </div>
    
      </a>
      
      </div>
      
      <div id="io767h" className="">
      
      <a
        target=""
        className="links "
        id="ibclo5"
        href="/"
        type="button"
      >
        
    <div id="i64dbt" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className="links "
        id="i28qdz"
        href="#"
        type="button"
      >
        
    <div id="i1xreu" className="">
    <>Búsqueda de Vehículos</>
    </div>
    
      </a>
      
      <a
        target=""
        className="links "
        id="idayty"
        href="#"
        type="button"
      >
        
    <div id="i0vg2v" className="">
    <>Cotización</>
    </div>
    
      </a>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="iwt1hr"
        className=""
        data-aos="fade-up"
        data-aos-duration="1000"
      >
      
      <div id="ihjr3o" className="">
      
      <div className="" id="iizaeu">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ijpl2e">
        <>¡PRECIOS NUNCA 
ANTES VISTOS!</>
      </span>
      
      </div>
      
      <div id="iozxpl" className="">
      
      <div id="itedql" className="">
      
      <div id="ivyo6u" className="">
      
        <div className="" id="iusqje">
          
      <form
        id="iqbpt8"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await customcrearharke_67351f269633993dfe9edac8({
						token: 'aasdas',
						tipov9p8x: e.target.tipov9p8x?.value,
						departamento3v8psl: e.target.departamento3v8psl?.value,
						nombreljaa1: e.target.nombreljaa1?.value,
						apellidocvq1d: e.target.apellidocvq1d?.value,
						identidadortnpfp8e: e.target.identidadortnpfp8e?.value,
						telfonojwptc: e.target.telfonojwptc?.value,
					});
					alert("Se envio exitosamente");
		} catch (error) {
					console.log(error);
					if (error.info) {
						alert(error.info);
					}
				}
			}}
		
      >
        
      <div id="ihth4p" className="">
      
      <div id="ics90s" className="">
      
      <div id="ii6atx" className="">
      
      <label id="i1exh" className="">
      <>Tipo</>
      </label>
      
      <br className="" id="" />
      
        <select
          name="tipov9p8x"
          className="input "
          id="i5wlak"
        >
          
        </select>
        
      </div>
      
      </div>
      
      <div id="il8713" className="">
      
      <div id="i91k7e" className="">
      
      <label id="ih2mc" className="">
      <>Departamento</>
      </label>
      
      <br className="" id="" />
      
        <select
          name="departamento3v8psl"
          className="input "
          id="i7c7rq"
        >
          
        </select>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="ie8nca" className="">
      
      <div id="i4vebl" className="">
      
      <div id="ir6yms" className="">
      
      <label id="" className="">
      <>Nombre</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="nombreljaa1"
        type="text"
        placeholder="Nombre"
        className="input "
        id="i4mwul"
      />
      
      </div>
      
      </div>
      
      <div id="ihaobl" className="">
      
      <div id="i4vxf5" className="">
      
      <label id="" className="">
      <>Apellido</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="apellidocvq1d"
        type="text"
        placeholder="Apellido"
        className="input "
        id="il6dm3"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3tb8i" className="">
      
      <label id="" className="">
      <>Identidad o RTN</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="identidadortnpfp8e"
        type="text"
        placeholder="Identidad o RTN"
        className="input "
        id="i1aexa"
      />
      
      </div>
      
      <div id="ix08y7" className="">
      
      <label id="" className="">
      <>Teléfono</>
      </label>
      
      <br className="" id="" />
      
      <input
        name="telfonojwptc"
        type="text"
        placeholder="Teléfono"
        className="input "
        id="ioq1a4"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="ijfner"
        className="standard_button modificado "
        
      >
      
      <div id="iyflrx" className="">
      <>Enviar</>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      <img
        className=""
        id="ikldpb"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim3j4s7un.png"
        alt="undefined"
      />
      
      </div>
      
      <button
        type=""
        name=""
        id="iqvggz"
        className="standard_button cotizaciones "
        onClick={async () => {
}}

      >
      
      <div id="iado6q" className="">
      
      <span className="" id="ivz26q">
        <>COTIZA AQUÍ</>
      </span>
      
      </div>
      
      </button>
      
      <div className="" id="iyinfc">
        
      <span className="" id="">
        
      </span>
      <>Tasas desde 13% anual y financiamiento hasta 72 meses. ¡Preaprobación inmediata al llenar el formulario!</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i4j8vo" className="">
      
      <video
        id="id9837"
        className=""
        src="https://assetsprojects.s3.amazonaws.com/j5ms1i1gm3k3aarm.mp4"
        loop={true}
        autoPlay={true}
        controls={false}
        muted={true}
        playsInline={true}
      />
      
      </div>
      
      <div id="ifq3sg" className="">
      
      <div id="is5k8f" className="">
      
      <div className="" id="i1qvp3">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i88oyj">
        <>AUTOFEST YA COMENZÓ</>
      </span>
      
      </div>
      
      </div>
      
      <div id="it7n3g" className="">
      
      <div id="i65r3w" className="">
      
      <div className="" id="iobmtm">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iarvxe">
        <>Cuenta</>
      <br className="" id="" />
      <>Rregresiva</>
      </span>
      
      </div>
      
      <div id="i5m3zb" className="">
      
      </div>
      
      </div>
      
      <span className="" id="ifl9ok">
        
      </span>
      
      <img
        className=""
        id="ihia5p"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim3j7fp8z.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="icxabj" className="">
      
      <div id="itgbub" className="">
      
      <div id="i4n5wk" className="">
      
      <div className="" id="io2s0j">
        
    <div id="il9p63" className="">
    
    <div id="" className="">
    
      <span className="" id="i7uilt">
        <>AUTOFEST YA COMENZÓ</>
      </span>
      
    </div>
    
    </div>
    
      <span className="" id="">
        
      </span>
      
      </div>
      
      </div>
      
      <span className="" id="itv317">
        
      </span>
      
      </div>
      
      </div>
      
      <div id="i6xx" className="">
      
      <div id="iir65o" className="">
      
      <div className="" id="igqyi">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="i3qhfy">
        <>ENCUENTRA TU VEHÍCULO</>
      </span>
      
      </div>
      
      <div id="iuu732" className="">
      
        <a
          target=""
          className=""
          id="ixg0cs"
          href="/vehiculos"
        >
          
    <div id="iselx6" className="">
    <>Ver más</>
    </div>
    
      <div id="iiipyl" className="">
      
      </div>
      
        </a>
        
      </div>
      
      </div>
      
        <div id="ipuecp" className="">
        
            {
              loftyres_6735058a9633993dfe9ed306_component_ipuecp.map((loftyitem_6735058a9633993dfe9ed306_component_ipuecp) => (
                <div key={loftyitem_6735058a9633993dfe9ed306_component_ipuecp._id} className="" id="ixg8or">
                  
      <div id="i5gjog" className="">
      
      <div id="i0n7fr" className="">
      
        <img
          className=""
          id="i503nx"
          alt=""
          src={loftyitem_6735058a9633993dfe9ed306_component_ipuecp.loftyUrl}
        />
        
      </div>
      
      <div id="isixvu" className="">
      
        <div className="" id="itat2e">
          
          <div className="" id="iibt0g">
            {loftyitem_6735058a9633993dfe9ed306_component_ipuecp?.nombrevehiculo5e65h}
          </div>
          
        </div>
        
        <a
          target=""
          className="standard_button "
          id="iypy3h"
          href={`/visualizacion/${loftyitem_6735058a9633993dfe9ed306_component_ipuecp._id}`}
        >
          
      <div id="ik70km" className="">
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      </div>
      
      <span className="" id="ihdfug">
        <>Ver vehículo</>
      </span>
      
        </a>
        
      </div>
      
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      <div id="i7x69l" className="">
      
      </div>
      
      <div id="i3dh" className="">
      
      <div id="iovivl" className="">
      
      <div className="" id="id1tkj">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="it1q5w">
        <>CLIENTES SATISFECHOS</>
      </span>
      
      </div>
      
      </div>
      
      <div className="" id="i93l3">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itg24k">
        <>Conoce algunos de nuestros clientes que con cada foto, cuentan una historia de confianza y satisfacción.</>
      </span>
      
      </div>
      
      <div id="ihp5j" className="">
      
      <div id="ic3u6r" className="">
      
      <img
        className=""
        id="igiten"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim37o7ctr.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i08g4i" className="">
      
      <img
        className=""
        id="ieb0gi"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim37o88zy.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ily5z4" className="">
      
      <img
        className=""
        id="i3sgq6"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim37o8a5a.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iv0g0l" className="">
      
      </div>
      
      <div id="i83rj4" className="">
      
      </div>
      
      <div id="ipjst4" className="">
      
      <div id="in4gsc" className="">
      
      <div className="" id="iy0bu7">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6s1k4">
        <>Búscanos en nuestras redes</>
      </span>
      
      </div>
      
      <div id="ilijmz" className="">
      
        <a
          target=""
          className=""
          id="i68lj2"
          href="mailto:sac@carmaxhn.com"
        >
          
      <img
        className=""
        id="i137py"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim37q453x.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="iqu7o1"
          href="https://www.instagram.com/carmaxhn/"
        >
          
      <img
        className=""
        id="iru1nq"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim37q475b.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="i6irgm"
          href="https://www.facebook.com/Carmaxhn"
        >
          
      <img
        className=""
        id="ix8eqg"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim37q465z.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="icd4wp"
          href="https://wa.me/message/NRUSGCZS27HCN1"
        >
          
      <img
        className=""
        id="iv9tbg"
        src="https://assetsprojects.s3.amazonaws.com/404no3im3kg8irs.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="imqdmc" className="">
      
      <div id="is16l4" className="">
      
      <div className="" id="iqj6i5">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itdh6f">
        <>Búscanos en nuestras redes</>
      </span>
      
      </div>
      
        <a
          target=""
          className=""
          id="iklg6x"
          href="#"
        >
          
        <a
          target=""
          className=""
          id="i9g4xj"
          href="mailto:sac@carmaxhn.com"
        >
          
      <img
        className=""
        id="irya7h"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim37q453x.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="i7qfbt"
          href="https://www.facebook.com/Carmaxhn"
        >
          
      <img
        className=""
        id="i7gf77"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim37q465z.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="i1dymt"
          href="https://www.instagram.com/carmaxhn/"
        >
          
      <img
        className=""
        id="i9veu5"
        src="https://assetsprojects.s3.amazonaws.com/404mwaim37q475b.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="ia2da3"
          href="https://wa.me/message/NRUSGCZS27HCN1"
        >
          
      <img
        className=""
        id="igd3of"
        src="https://assetsprojects.s3.amazonaws.com/404no3im3kg8irs.png"
        alt="undefined"
      />
      
        </a>
        
        </a>
        
      </div>
      
      </div>
      
      <div id="ilgjxb" className="">
      
      <div className="" id="iuyhhs">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i987ss">
        <>Grupo corporativo econo © 2024 | Todos los Derechos Reservados</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Ppaginaprincipaliigd5);
  